var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"question-title"},[_vm._v("\n  "+_vm._s(_vm.question.title)+"\n  "),(_vm.question.required)?_c('div',{staticClass:"is-small is-inline has-text-grey-light"},[_vm._v("\n    [required]\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }